import audio from 'assets/audio/three-beeps.mp3';

export const WorkoutPlayerCountdown = {
  bindings: {
    countdown: '<',
    waiting: '<',
    playing: '<',
  },

  template: `
    <div class="workout-player-countdown animated-progress-bar-container"
      ng-class="{ 'visible': $ctrl.visible }">
      <div class="progress-bar animated-progress-bar"
        ng-class="{ 'animation-on': $ctrl.animating }">
      </div>
      <div class="get-ready-text text-uppercase">
        Get Ready!
        <span class="time-remaining">
          {{ $ctrl.countdown === 0 ? 'GO!' : $ctrl.countdown }}
        </span>
      </div>
    </div>`,

  controller($element, $timeout) {
    'ngInject';

    return {
      $onInit() {
        this.visible = false;
        this.animating = false;
        this.audio = new Audio(audio);
      },

      $onChanges(changesObj) {
        this.clear();
        this.animate();
      },

      progressBar() {
        return $element.find('.progress-bar');
      },

      animate() {
        if (this.countdown === undefined) {
          return;
        }

        this.visible = this.countdown > 0 && this.playing;
        this.animating = this.visible && !this.waiting;

        if (this.countdown === 3) {
          $timeout(() => {
            const audioPromise = this.audio.play();

            // Shut the error messages up.
            if (audioPromise && audioPromise.catch) {
              audioPromise.catch(() => {});
            }
          });
        }
      },

      clear() {
        this.progressBar().attr('style', '');
      },

      matrix(value) {
        return String(value).match(/(-?[0-9\.]+)/g);
      },

      set() {
        const $el = this.progressBar();
        const matrix = this.matrix($el.css('transform'));

        let translateX = matrix && matrix[4];
        translateX = translateX / $element.width() * 100;

        const transform = `translate3d(${translateX}%, 0, 0)`;

        $el.css({
          '-webkit-transform': transform,
          '-moz-transform': transform,
          '-ms-transform': transform,
          '-o-transform': transform,
          transform: transform,
        });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerCountdown.js